export default __webpack_public_path__ + "static/media/hamburger.2a46033a.svg";